import MaximumSecurityComingSoonModal from './MaximumSecurityComingSoonModal.component';

export default MaximumSecurityComingSoonModal;
